{
    "RingtimeDistributionLabel": "Tempo di anello (distribuzione):",
    "RingtimeSegmentLabel": "Tempo di suoneria (segmento):",
    "CalltalktimeLabel": "Tempo di conversazione delle chiamate:",
    "TotalcalltimeLabel": "Tempo totale di chiamata:",
    "CallheldtimeLabel": "Tempo di attesa della chiamata:",
    "TimeComparisonAnyOptionLabel": "[Any]",
    "TimeComparisonHigherthanOptionLabel": "Superiore a",
    "TimeComparisonHigherequalOptionLabel": "Superiore\/uguale",
    "TimeComparisonLowerthanOptionLabel": "Inferiore a",
    "TimeComparisonLowerequalOptionLabel": "Inferiore\/uguale",
    "TimeComparisonBetweenOptionLabel": "Tra",
    "TimeComparisonEqualOptionLabel": "Pari",
    "TimeComparisonNotequalOptionLabel": "Non uguale",
    "TimeComparisonNotbetweenOptionLabel": "Non tra",
    "TimeComparisonValue1Label": "Valore:",
    "TimeComparisonValue2Label": "E:",
    "DurationFiltering_SectionHeader": "Filtraggio della durata (solo storico)",
    "NAME": "DurationFiltering"
}